import axios from "axios";
axios.defaults.headers.common["Is-Axios"] = true;
axios.defaults.headers["X-Requested-With"] = "Axios";
import Utilities from "../../../Helpers/Utilities";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { redirectToLoginPage } from "../../Account/Actions";
import { PRODUCT_SELECTED } from "../../Catalog/Constants";
import { SELECTED_KIT_PRODUCT_ID, SELECTED_DEVICE_PRODUCT_ID } from "../Constants";

export function getProductDetails(productId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, cb) {
    return function(dispatch, getState) {
        // dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Product/ProductDetail"), {
            params: { productId, includeSpecs, includeAttributes, includeSubProducts }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedProductDetails(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    dispatch(redirectToLoginPage());
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedProductDetails(data) {
    return {
        type: PRODUCT_SELECTED,
        payload: data
    };
}

export function setSelectedKitProductId(selectedProductId) {
    return {
        type: SELECTED_KIT_PRODUCT_ID,
        payload: selectedProductId
    };
}

export function setSelectedDeviceProductId(selectedProductId) {
    return {
        type: SELECTED_DEVICE_PRODUCT_ID,
        payload: selectedProductId
    };
}